<template>
  <div>
    <el-breadcrumb
      separator-class="el-icon-arrow-right"
      style="margin: 20px 0 20px 20px"
    >
      <el-breadcrumb-item>首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图 -->
    <el-card>
      <el-row :gutter="40">
        <el-col :span="20">
          <el-col :span="6">
            <el-input
              placeholder="请输入用户名"
              v-model="name"
              clearable
              @clear="getUserList"
            >
            </el-input>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" icon="el-icon-search" @click="getUserList"
              >查询</el-button
            >
          </el-col>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="addOrUpdateUser('add')"
            >添加用户</el-button
          >
        </el-col>
      </el-row>
    </el-card>

    <!-- 用户列表展示 -->
    <el-table :data="userList" border stripe>
      <!-- 索引列 -->
      <el-table-column type="index" label="索引" width="50px"></el-table-column>
      <el-table-column prop="username" label="姓名"></el-table-column>
      <el-table-column prop="roleId" label="角色">
        <template slot-scope="scope">
          <div v-for="(item, index) in scope.row.sysRoles" :key="index">
            <span>{{ item.name }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <!-- 利用自定义作用域插槽来解决在一个table-column里同时展示多个图标的问题 -->
        <template slot-scope="scope">
          <!-- 修改 -->
          <el-button
            type="primary"
            icon="el-icon-edit"
            size="mini"
            @click="addOrUpdateUser('Edit', scope.row)"
          ></el-button>
          <!-- 删除 -->
          <el-button
            type="danger"
            icon="el-icon-delete"
            size="mini"
            @click="delFn(scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页区域 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.pagenum"
      :page-sizes="[10]"
      :page-size="queryInfo.pagesize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>

    <el-dialog
      :title="isUpdate ? '编辑用户' : '添加用户'"
      :visible.sync="addDialogVisible"
      width="50%"
      @close="addDialogClosed"
    >
      <el-form
        :model="addForm"
        :rules="addFormRules"
        ref="addFormRef"
        label-width="70px"
      >
        <el-form-item label="用户名" prop="username">
          <el-input v-model="addForm.username"></el-input>
        </el-form-item>
        <el-form-item label="角色" prop="roleId">
          <el-select v-model="roleId" multiple placeholder="请选择角色">
            <el-option
              v-for="item in roleOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input type="password" v-model="addForm.password"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addUser('addFormRef')"
          >确 定</el-button
        >
        <el-button @click="addDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { createLogger } from 'vuex';
import userAxios from "../../api/adaptation";
export default {
  created() {
    this.getUserList();
    let data = {
        current: this.queryInfo.pagenum,
        size: this.queryInfo.pagesize,
        name: ''
      }
    userAxios.getAllRole(data).then(res => {
      console.log(res);
      res.list.map((item, i) => {
        let ll = {
          value: item.id,
          label: item.name
        }
        this.roleOptions.push(ll)
      })
    })
  },
  data() {
    return {
      roleOptions: [],
      roleValue: [],

      isUpdate: false,
      // 获取用户列表参数(有模糊查询)
      queryInfo: {
        // 当query为null时默认查询所有人的数据
        //当前页数
        pagenum: 1,
        //每一页展示的数据量
        pagesize: 10
      },
      userList: [],
      name: '',
      total: 0,
      // 是否展示提示框
      addDialogVisible: false,
      // 添加用户的数据对象
      addForm: {
        username: "",
        password: "",
      },
      roleId: [],
      addFormRules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          {
            min: 3,
            max: 10,
            message: "长度在 3 到 10 个字符",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 6,
            max: 15,
            message: "长度在 6 到 15 个字符",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    async getUserList() {
      let data = {
        pageNo: this.queryInfo.pagenum,
        pageSize: this.queryInfo.pagesize,
        username: this.name
      }
      const res = await userAxios.getAllUser(data);
      this.userList = res.data.records
      this.total = res.data.total
    },

    //监听底部分页栏 pagesize 改变的事件
    handleSizeChange(newSize) {
      console.log(newSize)
      this.queryInfo.pagesize = newSize;
      this.getUserList();
    },
    //监听底部分页面页码值发生改变的时间
    handleCurrentChange(newPage) {
      console.log(newPage)
      this.queryInfo.pagenum = newPage;
      this.getUserList();
    },
    // 当把添加用户框关闭的时候把数据清空
    addDialogClosed() {
      this.$refs.addFormRef.resetFields();
    },
    // 点击添加用户按钮时，给数据进行校验
    addUser(form) {
      if (this.roleId.join(',') == null || this.roleId.join(',') == '' || this.roleId.join(',').length == 0) {
        this.$message.error("请选择角色");
        return;
      }
      if (this.roleId.length > 2) {
        this.$message.error("只能选择两个角色");
        return;
      }
      this.$refs[form].validate((valid) => {
        if (!valid) return;
        if (this.isUpdate) {
          userAxios.updateUser({
            id: this.addForm.id,
            username: this.addForm.username,
            password: this.addForm.password
          }, this.roleId.join(',')).then(res => {
            this.$message({
              type: 'success',
              message: '修改成功!'
            });
            this.name = ''
            this.getUserList();
            this.addDialogVisible = false
          })
        } else {
          userAxios.addUser({
            username: this.addForm.username,
            password: this.addForm.password
          }, this.roleId.join(',')).then(res => {
            this.$message({
              type: 'success',
              message: '添加成功!'
            });
            this.name = ''
            this.getUserList();
            this.addDialogVisible = false
          })
        }
      })

    },
    // 添加或者更新用户
    addOrUpdateUser(type, row) {
      let self = this
      self.addForm = {
        username: "",
        password: ""
      }
      if (type === 'add') {
        self.roleId = []
        self.isUpdate = false
      } else {
        self.isUpdate = true
        self.addForm = JSON.parse(JSON.stringify(row))
        self.roleId = []
        for (let i = 0; i < row.sysRoles.length; i++) {
          self.roleId.push(row.sysRoles[i].id)
        }
      }
      self.addDialogVisible = true
    },
    delFn(row) {
      this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        userAxios.deleteById(row.id).then(res => {
          this.getUserList();
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 上一页
    // prevClick() {
    //   this.queryInfo.current--
    // },
    // 下一页
    // nextClick() {
    //   this.queryInfo.current++
    // }
  },
};
</script>

<style lang="less" scoped>
</style>